import { render } from "./InformationWell.vue?vue&type=template&id=43bfcb03"
import script from "./InformationWell.vue?vue&type=script&lang=js"
export * from "./InformationWell.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__